// Hindi localization - Main index file
import auth from "./auth.json";
import businessPlan from "./businessPlan.json";
import categories from "./categories.json";
import commissions from "./commissions.json";
import common from "./common.json";
import customer from "./customer.json";
import dashboard from "./dashboard.json";
import dispatch from "./dispatch.json";
import events from "./events.json";
import forms from "./forms.json";
import manualApproval from "./manualApproval.json";
import navigation from "./navigation.json";
import order from "./order.json";
import products from "./products.json";
import profile from "./profile.json";
import publicPages from "./public.json";
import publicContent from "./publicContent.json";
import referrals from "./referrals.json";
import shipping from "./shipping.json";
import status from "./status.json";
import teamNetwork from "./teamNetwork.json";
import tracking from "./tracking.json";
import users from "./users.json";
import wallet from "./wallet.json";

export default {
  common,
  navigation,
  publicContent,
  publicPages,
  businessPlan,
  categories,
  auth,
  teamNetwork,
  profile,
  dashboard,
  shipping,
  status,
  users,
  products,
  order,
  commissions,
  referrals,
  forms,
  manualApproval,
  dispatch,
  customer,
  tracking,
  events,
  wallet,
};
